module.exports = __webpack_public_path__ + "static/media/background_image.8b21150b.jpeg";